import React from 'react';

import Page from 'components/App/Page';
import {PageHeader} from 'components/v3/common/page-header/page-header';

import CreateAppForm from './CreateApp/CreateAppForm';

const Onboarding = () => {
  return (
    <div>
      <Page title="Welcome to NoRamp" padding>
        <PageHeader title="Create your first App" />
        <div className="flex flex-col p-4">
          <div className="flex max-w-lg overflow-auto">
            <CreateAppForm />
          </div>
        </div>
      </Page>
    </div>
  );
};

export default Onboarding;
